var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bigImageWithRate"},[_c('BigImage',{attrs:{"src":_vm.src}}),_c('div',{staticClass:"rate"},[_c('img',{attrs:{"src":require("@/assets/images/icons/star.svg"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.rate))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }